import PropTypes from "prop-types";
import React, { Component } from "react";
import "./Toggle2.css";

export default class Toggle2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
        aggregate:false
    };
  }


 

  render() {
    window.toggleState = this.props.toggleState
    const { toggleState, toggleFun } = this.props;
    return (
      <div className="aggregate">
          <button onClick={toggleFun} className={toggleState ? 'actv' : ''}>
        <i className={'fa fa-toggle-' + (toggleState ? 'on' : 'off')}></i> Aggregate
    </button> 
      </div>
    );
  }
}

